import React from 'react';
import cx from 'classnames';
import { StyledParagraph } from './styles';
export const Paragraph = (props) => {
    return (React.createElement(StyledParagraph, { "data-role": "paragraph", line: props.line, type: props.type, className: cx('paragraph', props.className) }, props.children));
};
